var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4603 47.5602C44.6663 47.5602 54.6128 37.6358 54.6128 25.4076C54.6128 13.2016 44.6663 3.25513 32.4603 3.25513C20.2321 3.25513 10.3077 13.2016 10.3077 25.4076C10.3077 37.4286 19.8985 47.2231 31.8405 47.5517L32.4603 47.5602Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1015 15.8984C40.9208 15.7178 40.6952 15.5886 40.4479 15.5241C40.2007 15.4596 39.9407 15.4621 39.6948 15.5314L22.9544 20.253C22.6727 20.3325 22.422 20.496 22.2358 20.7217C22.0495 20.9475 21.9366 21.2247 21.9121 21.5163C21.8877 21.8079 21.9528 22.1001 22.0988 22.3537C22.2448 22.6073 22.4648 22.8104 22.7292 22.9356L29.7311 26.2523L34.5182 21.4652C34.653 21.3304 34.8358 21.2547 35.0264 21.2547C35.2171 21.2547 35.3999 21.3304 35.5347 21.4652C35.6695 21.6 35.7452 21.7829 35.7452 21.9735C35.7452 22.1641 35.6695 22.347 35.5347 22.4818L30.7476 27.2688L34.0643 34.2707C34.1792 34.517 34.3622 34.7254 34.5916 34.8711C34.8211 35.0168 35.0875 35.0938 35.3593 35.093C35.4005 35.093 35.4419 35.0912 35.4836 35.0878C35.7758 35.0649 36.0538 34.9526 36.2798 34.7661C36.5059 34.5796 36.6689 34.328 36.7469 34.0455L41.4685 17.3051C41.5377 17.0592 41.5402 16.7992 41.4757 16.552C41.4112 16.3048 41.282 16.0792 41.1015 15.8984Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -2.71252,
    y: -9.76513,
    width: 70.3456,
    height: 70.3456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.51013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.50012,
    y1: -22.9999,
    x2: -14.9999,
    y2: 39.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B5DFE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send2.89cdbc6a69694824dcedaafa2e9d2a66.svg";
export { ForwardRef as ReactComponent };